import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import {resources} from './resources';
import {DEFAULT_LANGUAGE, detectInitialLanguage} from './config';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    supportedLngs: ['en', 'ar', 'fr'],
  });

export default i18n;

